import { WorklistContextState } from './worklistContext';
import { OptionType } from '@/app/components/Worklist/types';

export enum ACTIONS {
    GET_UNIT_ORG_TREE,
    GET_UNIT_ORG_TREE_DONE,
    GET_UNIT_ORG_TREE_ERROR,
}

export default (state: WorklistContextState, action: any) => {
    switch (action.type) {
        case ACTIONS.GET_UNIT_ORG_TREE_DONE: {
            return {
                ...state,
                organization: {
                    ...state.organization,
                    orgTree: action.payload,
                    allUnitOptions: action.payload.map((u): OptionType => ({value: u.unitId, label: u.name})),
                }
            };
        }
        default:
            return state;
    }
};
